import { reactive } from 'cdui-js';
import { fetchDepositsList } from '../../../../api/funds';
import { FundCard } from './FundCard';

export const DepoRecords = () => {
  const state = reactive({
    list: [],
  });

  const fetchList = async () => {
    const res = (await fetchDepositsList()) as any;
    state.list = res.list;
  };

  fetchList();

  return (
    <div>
      {state.list.map((row) => {
        return <FundCard data={row} />;
      })}
    </div>
  );
};
